import { trackAssessmentEvent } from '../../lib/analytics/events'
import { loadAssessmentState } from '../../lib/assessment/session'
import { mountReport, mountResults } from './results'
import { mountWizard } from './wizard'

function boot(): void {
  const root = document.getElementById('assessment-root')
  if (!root) return

  const page = root.dataset.page || 'landing'
  const state = loadAssessmentState()

  if (page === 'landing') {
    trackAssessmentEvent('assessment_view')
    return
  }
  if (page === 'start') {
    mountWizard(root, state)
    return
  }
  if (page === 'results') {
    mountResults(root, state)
    return
  }
  if (page === 'report') {
    mountReport(root, state)
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot)
} else {
  boot()
}
